(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  var cards = document.querySelectorAll('.cat-card.reveal');
  if (!cards.length) return;

  function show(el) { el.classList.add('visible'); }

  if (!('IntersectionObserver' in window)) {
    cards.forEach(show);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        show(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  cards.forEach(function (card) { observer.observe(card); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-collection-filters]');
    if (!bar) return;

    var groups = document.querySelectorAll('.collection-group[data-group]');

    bar.addEventListener('click', function (event) {
      var button = event.target.closest('.collection-filter');
      if (!button) return;

      var filter = button.dataset.filter;

      bar.querySelectorAll('.collection-filter').forEach(function (el) {
        el.classList.toggle('is-active', el === button);
      });

      groups.forEach(function (group) {
        group.hidden = filter !== 'all' && group.dataset.group !== filter;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('RettroContactForm');
  if (!form) return;
  var topic = form.querySelector('[data-rcp-topic]');
  var conditional = form.querySelectorAll('[data-rcp-show]');
  var errorEl = form.querySelector('[data-rcp-error]');

  function syncConditional() {
    conditional.forEach(function (wrap) {
      var show = topic.value === wrap.getAttribute('data-rcp-show');
      wrap.hidden = !show;
      wrap.querySelectorAll('input').forEach(function (input) { input.disabled = !show; });
    });
  }
  topic.addEventListener('change', syncConditional);
  syncConditional();

  form.addEventListener('submit', function (event) {
    var valid = true;
    form.querySelectorAll('[required]').forEach(function (field) {
      var ok = field.value.trim() !== '' && (!field.checkValidity || field.checkValidity());
      field.classList.toggle('rcp-invalid', !ok);
      if (!ok) valid = false;
    });
    errorEl.hidden = valid;
    if (!valid) event.preventDefault();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expert-quotes"] && !Shopify.designMode) return;
  try {
    
function handleEmail(e) {
  e.preventDefault();
  const btn = e.target.querySelector('button');
  btn.textContent = '🎉 Claimed!';
  btn.style.background = 'var(--green)';
  setTimeout(() => { btn.textContent = 'Claim ₹100 Off →'; btn.style.background = ''; }, 3000);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-crew"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-footer-toggle]');
    if (!toggle) return;
    var col = toggle.closest('.footer-col');
    var open = !col.classList.contains('is-open');
    col.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  /* Scroll shadow */
  var nav = document.getElementById('mainNav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* Mobile toggle */
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.getElementById('navMobileDrawer');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var isOpen = !drawer.hidden;
      drawer.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
// Nav scroll effect
window.addEventListener('scroll', () => {
  const nav = document.getElementById('mainNav');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 20);
});

// Scroll reveal
const reveals = document.querySelectorAll('.reveal');
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('visible'); }
  });
}, { threshold: 0.12 });
reveals.forEach(r => revealObserver.observe(r));

// Hero slider
(function() {
  var cards = document.querySelectorAll('#hpcSliderWrap .hpc-card-slide');
  var dots = document.querySelectorAll('#hpcDots .hsd-dot');
  var current = 0;
  var total = cards.length;
  var autoTimer;

  if (!total) return;

  function goTo(idx) {
    cards[current].classList.remove('hpc-card-active');
    dots[current].classList.remove('hsd-active');
    current = (idx + total) % total;
    cards[current].classList.add('hpc-card-active');
    dots[current].classList.add('hsd-active');
  }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      clearInterval(autoTimer);
      goTo(parseInt(this.dataset.index));
      startAuto();
    });
  });

  function startAuto() {
    autoTimer = setInterval(function() { goTo(current + 1); }, 4500);
  }
  startAuto();
})();

// Hero right panel image slider
(function() {
  var slides = document.querySelectorAll('.hrp-slide');
  var dots = document.querySelectorAll('.hrp-dot');
  if (!slides.length) return;
  var current = 0;
  function goTo(idx) {
    slides[current].style.opacity = '0';
    if (dots[current]) { dots[current].style.background = 'rgba(255,255,255,0.4)'; dots[current].style.transform = 'scale(1)'; }
    current = (idx + slides.length) % slides.length;
    slides[current].style.opacity = '1';
    if (dots[current]) { dots[current].style.background = '#fff'; dots[current].style.transform = 'scale(1.3)'; }
  }
  dots.forEach(function(dot, i) { dot.addEventListener('click', function() { goTo(i); }); });
  setInterval(function() { goTo(current + 1); }, 3500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrition-science"] && !Shopify.designMode) return;
  try {
    
  // Nutrition bars animate on scroll
  const barFills = document.querySelectorAll('.nutri-bar-fill');
  const barObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.width = e.target.style.width;
        barObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.5 });
  barFills.forEach(b => {
    const w = b.style.width;
    b.style.width = '0';
    setTimeout(() => b.style.width = w, 100);
    barObserver.observe(b);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  /* ── Gallery ── */
  var slides  = Array.from(document.querySelectorAll('[data-slide]'));
  var dots    = Array.from(document.querySelectorAll('[data-dot]'));
  var thumbs  = Array.from(document.querySelectorAll('[data-thumb]'));

  function goSlide(idx) {
    slides.forEach(function (s) { s.classList.toggle('is-active', Number(s.dataset.slide) === idx); });
    dots.forEach(function (d) {
      var active = Number(d.dataset.dot) === idx;
      d.classList.toggle('is-active', active);
      d.setAttribute('aria-selected', String(active));
    });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', Number(t.dataset.thumb) === idx); });
  }

  dots.forEach(function (d) { d.addEventListener('click', function () { goSlide(Number(d.dataset.dot)); }); });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { goSlide(Number(t.dataset.thumb)); }); });

  /* ── Main image prev/next arrows ── */
  function currentSlideIndex() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) return Number(slides[i].dataset.slide) || i;
    }
    return 0;
  }
  function goSlideRelative(step) {
    if (!slides.length) return;
    var n = ((currentSlideIndex() + step) % slides.length + slides.length) % slides.length;
    goSlide(n);
    /* keep active thumb visible */
    var activeThumb = document.querySelector('.pdp-thumb.is-active');
    if (activeThumb && activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }
  var slidePrev = document.querySelector('[data-slide-prev]');
  var slideNext = document.querySelector('[data-slide-next]');
  if (slidePrev) slidePrev.addEventListener('click', function () { goSlideRelative(-1); });
  if (slideNext) slideNext.addEventListener('click', function () { goSlideRelative(1); });

  /* ── Thumbnail swiper arrows ── */
  var scrollLeftBtn = document.querySelector('[data-thumb-scroll-left]');
  var scrollRightBtn = document.querySelector('[data-thumb-scroll-right]');
  var thumbsWrap = document.querySelector('.pdp-thumbs');

  function updateThumbArrows() {
    if (!thumbsWrap || !scrollLeftBtn || !scrollRightBtn) return;
    var atStart = thumbsWrap.scrollLeft <= 0;
    var atEnd = thumbsWrap.scrollLeft + thumbsWrap.clientWidth >= thumbsWrap.scrollWidth - 1;
    scrollLeftBtn.classList.toggle('is-hidden', atStart);
    scrollRightBtn.classList.toggle('is-hidden', atEnd);
  }

  if (scrollLeftBtn && thumbsWrap) {
    scrollLeftBtn.addEventListener('click', function () {
      thumbsWrap.scrollBy({ left: -130, behavior: 'smooth' });
    });
  }
  if (scrollRightBtn && thumbsWrap) {
    scrollRightBtn.addEventListener('click', function () {
      thumbsWrap.scrollBy({ left: 130, behavior: 'smooth' });
    });
  }
  if (thumbsWrap) {
    thumbsWrap.addEventListener('scroll', updateThumbArrows);
    updateThumbArrows();
  }

  /* dummy thumb logic moved to inline script for reliability */

  /* ── Qty ── */
  var form     = document.getElementById('pdp-form');
  if (!form) return;

  var qtyInput = form.querySelector('[data-qty-input]');
  var minusBtn = form.querySelector('[data-qty-minus]');
  var plusBtn  = form.querySelector('[data-qty-plus]');
  var atcBtn   = form.querySelector('[data-atc-btn]');
  var priceEl  = document.querySelector('[data-price]');
  var cmpEl    = document.querySelector('[data-compare]');
  var saveEl   = document.querySelector('[data-save]');
  var perGEl   = document.querySelector('[data-per-gram]');
  var moneyFmt = document.querySelector('[data-money-format]');
  var fmt      = (moneyFmt && moneyFmt.dataset.moneyFormat) || '₹{{amount}}';

  function money(cents) {
    var a = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, a)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  }

  if (minusBtn) minusBtn.addEventListener('click', function () {
    qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
  });
  if (plusBtn) plusBtn.addEventListener('click', function () {
    qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
  });

  /* ── Variant pills ── */
  var pills = Array.from(form.querySelectorAll('.pdp-variant-pill input'));
  pills.forEach(function (radio) {
    radio.addEventListener('change', function () {
      pills.forEach(function (r) {
        r.closest('.pdp-variant-pill').classList.toggle('is-active', r === radio);
      });

      var price   = parseInt(radio.dataset.price   || 0, 10);
      var compare = parseInt(radio.dataset.compare || 0, 10);
      var weight  = parseInt(radio.dataset.weight  || 0, 10);
      var onSale  = compare > price;

      if (priceEl) priceEl.textContent = money(price);
      if (cmpEl)   { cmpEl.textContent = onSale ? money(compare) : ''; cmpEl.hidden = !onSale; }
      if (saveEl)  {
        if (onSale) {
          saveEl.textContent = 'Save ' + Math.round((compare - price) / compare * 100) + '%';
          saveEl.hidden = false;
        } else { saveEl.hidden = true; }
      }
      if (perGEl && weight > 0) {
        perGEl.textContent = '₹' + (price / weight / 100).toFixed(2) + ' / g';
        perGEl.hidden = false;
      } else if (perGEl) { perGEl.hidden = true; }

      /* Update title weight badge */
      var titleWeightEl = document.getElementById('pdpTitleWeight');
      if (titleWeightEl) {
        if (weight > 0) {
          titleWeightEl.textContent = ' — ' + Math.round(weight) + ' g';
          titleWeightEl.style.display = '';
        } else {
          titleWeightEl.style.display = 'none';
        }
      }

      /* image swap */
      if (radio.dataset.imageSrc) {
        var idx = parseInt(radio.dataset.imageIdx || 0, 10);
        goSlide(idx);
        var activeSlide = slides[idx];
        if (activeSlide) {
          var img = activeSlide.querySelector('img');
          if (img) { img.src = radio.dataset.imageSrc; }
        }
      }

      /* ATC state */
      var avail = !radio.disabled;
      if (atcBtn) {
        atcBtn.disabled = !avail;
        atcBtn.textContent = 'Add to cart';
      }
    });
  });

  /* ── Pincode ── */
  var pincodeBtn = document.querySelector('[data-pincode-check]');
  var pincodeInput = document.getElementById('pdpPincode');
  var pincodeResult = document.querySelector('[data-pincode-result]');
  if (pincodeBtn && pincodeInput && pincodeResult) {
    pincodeBtn.addEventListener('click', function () {
      var pin = pincodeInput.value.trim();
      if (pin.length !== 6 || !/^\d{6}$/.test(pin)) {
        pincodeResult.textContent = 'Please enter a valid 6-digit pincode.';
        pincodeResult.className = 'pdp-pincode-result is-error';
        pincodeResult.hidden = false;
        return;
      }
      pincodeBtn.textContent = '...';
      pincodeResult.hidden = true;
      setTimeout(function () {
        pincodeResult.textContent = '✓ Delivery available to ' + pin + ' within 3–5 business days.';
        pincodeResult.className = 'pdp-pincode-result';
        pincodeResult.hidden = false;
        pincodeBtn.textContent = 'Check';
      }, 800);
    });
  }

  /* ── Add to cart ── */
  var timer;
  form.addEventListener('submit', function (e) {
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    if (!atcBtn || atcBtn.disabled) return;

    var variantId = (form.querySelector('input[name="id"]:checked') ||
                     form.querySelector('input[name="id"]') || {}).value;
    var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    if (!variantId) return;

    clearTimeout(timer);
    atcBtn.disabled = true;
    atcBtn.classList.add('is-loading');
    atcBtn.textContent = 'Adding…';

    var req;
    if (window.CartDrawer && typeof window.CartDrawer.addItem === 'function') {
      req = window.CartDrawer.addItem(variantId, qty);
    } else {
      req = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: qty })
      }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); });
    }

    Promise.resolve(req)
      .then(function () {
        atcBtn.classList.remove('is-loading');
        atcBtn.classList.add('is-success');
        atcBtn.textContent = 'Added ✓';
        /* refresh cart badge */
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var badge = document.getElementById('headerCartCount');
          if (badge) { badge.textContent = c.item_count; badge.style.display = c.item_count > 0 ? '' : 'none'; }
        });
        timer = setTimeout(function () {
          atcBtn.classList.remove('is-success');
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to cart';
        }, 2200);
      })
      .catch(function () {
        atcBtn.classList.remove('is-loading');
        atcBtn.classList.add('is-error');
        atcBtn.textContent = 'Error — try again';
        timer = setTimeout(function () {
          atcBtn.classList.remove('is-error');
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to cart';
        }, 2500);
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protein-science"] && !Shopify.designMode) return;
  try {
    
(function () {
  var panel = document.getElementById('proteinBars');
  if (!panel) return;

  function animateBars() {
    panel.querySelectorAll('.ps-bar-fill').forEach(function (bar) {
      bar.style.width = (bar.dataset.w || 0) + '%';
    });
  }

  if (!('IntersectionObserver' in window)) { animateBars(); return; }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateBars();
        observer.disconnect();
      }
    });
  }, { threshold: 0.3 });

  observer.observe(panel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var w = document.querySelector('[data-rp-url]');
  if (!w) return;
  var sid = w.closest('.shopify-section');
  var id = sid ? sid.id.replace('shopify-section-', '') : '';
  fetch(w.getAttribute('data-rp-url') + '&section_id=' + id)
    .then(function (r) { return r.text(); })
    .then(function (h) {
      var d = new DOMParser().parseFromString(h, 'text/html');
      var g = d.querySelector('.rp__row');
      if (g && g.children.length > 0) {
        var t = w.querySelector('.rp__row');
        if (t) t.innerHTML = g.innerHTML;
      }
      bind(w);
    }).catch(function () {});
  bind(w);

  function bind(el) {
    el.querySelectorAll('[data-rp-atc]').forEach(function (b) {
      if (b.dataset.rpB) return;
      b.dataset.rpB = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var vid = b.getAttribute('data-variant-id');
        if (!vid || b.disabled) return;
        b.disabled = true;
        var req = (window.CartDrawer && window.CartDrawer.addItem)
          ? window.CartDrawer.addItem(vid, 1)
          : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(vid), quantity: 1 }) }).then(function (r) { if (!r.ok) throw 0; return r.json(); });
        Promise.resolve(req).then(function () {
          b.classList.add('is-success');
          b.innerHTML = '<svg width="16" height="16" viewBox="0 0 22 22" fill="none"><path d="M6 11.5l3.5 3.5 6.5-7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var bg = document.getElementById('headerCartCount');
            if (bg) { bg.textContent = c.item_count; bg.style.display = c.item_count > 0 ? '' : 'none'; }
          });
          setTimeout(function () {
            b.classList.remove('is-success'); b.disabled = false;
            b.innerHTML = '<svg width="18" height="18" viewBox="0 0 22 22" fill="none"><path d="M11 5v12M5 11h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
          }, 2400);
        }).catch(function () { b.disabled = false; });
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rettro-homepage"] && !Shopify.designMode) return;
  try {
    
// Nav scroll
  window.addEventListener('scroll', () => {
    const nav = document.getElementById('mainNav');
    nav.classList.toggle('scrolled', window.scrollY > 20);
  });

  // Scroll reveal
  const reveals = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); }
    });
  }, { threshold: 0.12 });
  reveals.forEach(r => observer.observe(r));

  // Email form
  function handleEmail(e) {
    e.preventDefault();
    const btn = e.target.querySelector('button');
    btn.textContent = '🎉 Claimed!';
    btn.style.background = 'var(--green)';
    setTimeout(() => { btn.textContent = 'Claim ₹100 Off →'; btn.style.background = ''; }, 3000);
  }

  // Nutrition bars animate on scroll
  const barFills = document.querySelectorAll('.nutri-bar-fill');
  const barObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.width = e.target.style.width;
        barObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.5 });
  barFills.forEach(b => {
    const w = b.style.width;
    b.style.width = '0';
    setTimeout(() => b.style.width = w, 100);
    barObserver.observe(b);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-polaroid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function cardsOf(track) { return Array.prototype.slice.call(track.querySelectorAll('.tp-polaroid')); }

  function sync(track) {
    var dots = track.parentNode.querySelectorAll('[data-tp-dot]');
    if (!dots.length) return;
    var mid = track.scrollLeft + track.clientWidth / 2;
    var best = 0, bestDist = Infinity;
    cardsOf(track).forEach(function (card, i) {
      var dist = Math.abs(card.offsetLeft + card.offsetWidth / 2 - mid);
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    Array.prototype.forEach.call(dots, function (dot, i) { dot.classList.toggle('is-active', i === best); });
  }

  // Start each slider on its middle card so the centre testimonial is the active one.
  function centreOn(track, card, smooth) {
    track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
  }
  function initTracks() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tp-track]'), function (track) {
      if (track.scrollWidth <= track.clientWidth) return;
      var cards = cardsOf(track);
      var mid = cards[Math.floor(cards.length / 2)];
      if (mid) { centreOn(track, mid, false); sync(track); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTracks);
  else initTracks();
  document.addEventListener('shopify:section:load', initTracks);

  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (track.nodeType === 1 && track.hasAttribute('data-tp-track')) sync(track);
  }, true);

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('[data-tp-dot]');
    if (!dot) return;
    var track = dot.closest('.tp-wrap').querySelector('[data-tp-track]');
    var card = cardsOf(track)[Number(dot.getAttribute('data-tp-dot'))];
    if (!card) return;
    centreOn(track, card, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wr-scroll-reveal"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (typeof IntersectionObserver === 'undefined') {
    document.querySelectorAll('.wr-reveal,.wr-reveal-stagger').forEach(function(el){ el.classList.add('wr-is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){
        e.target.classList.add('wr-is-visible');
        io.unobserve(e.target);
      }
    });
  }, {threshold:0.12, rootMargin:'0px 0px -40px 0px'});

  var sels = [
    '.wr-def-inner > *',
    '.wr-pillars .wr-eyebrow', '.wr-pillars .wr-section-title', '.wr-pillars .wr-pillars-intro', '.wr-pillar-row',
    '.wr-science .wr-eyebrow', '.wr-science .wr-section-title', '.wr-science .wr-science-intro', '.wr-ing-pills', '.wr-steps',
    '.wr-works .wr-eyebrow', '.wr-works .wr-section-title', '.wr-works-row', '.wr-closer',
    '.wr-no-list .wr-eyebrow--yellow', '.wr-no-list-h2', '.wr-no-line',
    '.wr-manifesto-rule', '.wr-manifesto-h2', '.wr-manifesto-p', '.wr-ctas'
  ];
  sels.forEach(function(s){
    document.querySelectorAll(s).forEach(function(el){
      el.classList.add('wr-reveal');
      io.observe(el);
    });
  });

  ['.wr-pillar-row','.wr-steps','.wr-works-row','.wr-no-line','.wr-ing-pills'].forEach(function(s){
    var el = document.querySelector(s);
    if (el) el.classList.add('wr-reveal-stagger');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
